<template>
  <div
    class="sequence-picker"
    :style="`
      ${width?`width: ${width};`:''}
      `"
    >
    <div class="sequence-picker-header">
      <slot name="header"/>
    </div>
    <div class="sequence-picker-sequence" :style="`${overflow_hidden ? 'flex-wrap: no-wrap; overflow: hidden;': 'flex-wrap: wrap'}`">
      <slot name="sequence" :prefix="prefix"/>
    </div>
    <div class="sequence-picker-subheader">
      <slot name="subheader"/>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['template_type', 'width', 'overflow_hidden'],
    computed: {
      prefix() {
        let prefix = '';
        switch (this.template_type) {
          case 'custom':
            break;
          case 'business':
            prefix = 'b';
            break;
          case 'community':
            prefix = 'c';
            break;
        }
        return prefix;
      }
    }
  }
</script>
<style>
  .sequence-picker {
    display: flex;
    flex-direction: column;
    transition: background-color 0.1s ease-in-out;
    cursor: pointer;
  }
  .sequence-picker:hover {
    background-color: rgba(255,255,255,0.08);
    /* background-color: #03A9F4; */
  }
  .sequence-picker-header {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    color: var(--v-primary);
    opacity: 0.9;
  }
  .sequence-picker-subheader {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-size: 10px;
    line-height: 10px;
  }
  .sequence-picker-sequence {
    display: flex;
    flex-direction: row;
    /* flex-wrap: wrap; */
  }
</style>
